export class ProjectSampleRequestDTO {
  public salutation: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public emailAddress: string = '';
  public phoneNumber: string = '';
  public street: string = '';
  public city: string = '';
  public country: string = '';
  public zipCode: string = '';
  public houseNumber: string = '';

  public company: string = '';
  public department: string = '';
  public customerNumber: string = '';

  public amount: string = '';
  public estimatedAnnualDemand: string = '';
  public applicationDescription: string = '';

  public localeKey: string = '';
  public projectVersion: number = 0;
}
